// Presets de fraîcheur React Query — cf. docs/superpowers/specs/2026-07-16-data-freshness-presets-design.md
//
// Le défaut global (apps/web/src/main.tsx) est refetchOnWindowFocus: false.
// Chaque useQuery étale le preset correspondant à son niveau : useQuery({ ...LIVE, queryKey, queryFn }).
//
// RÈGLE : une donnée déjà poussée en Realtime ne prend JAMAIS le preset LIVE — le push
// assure la fraîcheur, un polling en plus paierait deux fois la même chose.

/**
 * Donnée collaborative SANS Realtime : polling court.
 * refetchIntervalInBackground: false → le polling se suspend quand l'onglet est caché.
 */
export const LIVE = {
  staleTime: 15_000,
  refetchInterval: 60_000,
  refetchIntervalInBackground: false,
} as const;

/**
 * Cloche in-app : Realtime `notifications` n’est plus dans la publication.
 * Poll 2 min, pause onglet caché. Pas de toast d’historique (voir signatureAlertToast).
 */
export const POLL_2MIN = {
  staleTime: 30_000,
  refetchInterval: 120_000,
  refetchIntervalInBackground: false,
} as const;

/**
 * Donnée semi-fraîche : pas de polling, mais refetch au retour d'onglet.
 * Seul preset qui réactive explicitement refetchOnWindowFocus.
 */
export const SEMI_FRESH = {
  staleTime: 30_000,
  refetchOnWindowFocus: true,
} as const;

/**
 * Donnée quasi-statique OU déjà couverte par du Realtime.
 * Fraîcheur assurée par invalidateQueries sur mutation, jamais par focus ni polling.
 */
export const STATIC = {
  staleTime: 600_000,
} as const;
